<template>
    <row v-if="name">
        <col3>
          {{name}}
          <info-icon v-if="showInfoIcon" :text="infoIconText"></info-icon>
        </col3>
      <col3 v-if="yesno">
        <v-switch
            style="margin-top: 0px; margin-left: 5px; padding-top: 0px"
            inset
            :model-value="_yesno_value"
            @update:model-value="toggleSwitch"
            :label="''"
            color="primary"
            :disabled="disabled"
            hide-details
        ></v-switch>
      </col3>
      <col3 v-else-if="str_options">
          <autocomplete
                  :rounded="false"
                  @select="select"
                  :value="selected_option"
                  :options="str_options"
                  :disabled="disabled"></autocomplete>
      </col3>
      <col3 v-if="input">
        <v-text-field
              @input="select"
              :value="value"
              dense outlined
              :disabled="disabled"
              ></v-text-field>
      </col3>
      <col3 v-if="name.includes('filters')">
        <filter-list
          :key="filterListRemountKey"
          @update="update"
          :json_filters="value"
        ></filter-list>
      </col3>

    </row>
</template>

<script>
  import Row from "@/components/layout/Row";
  import Col3 from "@/components/layout/Col3";
  import Autocomplete from "@/components/Autocomplete";
  import InfoIcon from '@/components/notifications/InfoIcon.vue';
  import FilterList from "@/components/train_configs/FilterList";

  export default {
    name: "Parameter",
    components: {Autocomplete, Col3, Row, InfoIcon, FilterList},
    props: {
      'name': {required: true},
      'value': {default: null},
      'input': {default: null},
      'default_value': {required: true},
      'options': {required: true},
      'disabled': {type: Boolean, default:false},
    },
    data() {
      return {
        '_yesno_value': false,
      }
    },
    watch: {
      value: {
        immediate: true,
        handler(newValue) {
          const yesnoValue = this.isYes(newValue);
          console.log('[Parameter]', this.name, 'value prop changed ->', newValue, 'parsed as yesno:', yesnoValue);
          this._yesno_value = yesnoValue;
        }
      }
    },
    methods: {
      isYes(value) {
        if (typeof value === 'string') {
          return value.toLowerCase() === 'yes' || value.toLowerCase() === 'true';
        }
        return value === true;
      },
      update(values) {
        this.select(values)
      },
      toggleSwitch(value) {
        // Vuetify 3: use update:modelValue (boolean). Native @change passes an Event
        // object which is always truthy, so toggle-off incorrectly saved as "Yes".
        const on = value === true;
        console.log('[Parameter]', this.name, 'toggleSwitch fired with', value, '->', on);
        this._yesno_value = on;
        this.select(on ? 'Yes' : 'No');
      },
      select(value) {
        console.log('[Parameter]', this.name, 'emitting select event with value:', value);
        this.$emit('select', value)
      },
      convert_parameter_name(name) {
        return name.toLowerCase().replace('_', ' ');
      }
    },
    computed: {
      /** Remount FilterList when saved meta arrives so chips reflect loaded JSON. */
      filterListRemountKey() {
        const v = this.value;
        if (v == null || v === '') {
          return `${this.name}:empty`;
        }
        if (typeof v === 'string') {
          return `${this.name}:s:${v.length}:${v.slice(0, 48)}`;
        }
        if (Array.isArray(v)) {
          return `${this.name}:a:${v.length}`;
        }
        return `${this.name}:o`;
      },
      showInfoIcon() {
        return this.infoIconTranslationKey !== null;
      },
      /** Locale key under models_and_train_configs, or null when no tooltip. */
      infoIconTranslationKey() {
        const parameterName = this.convert_parameter_name(this.name);
        const byExact = {
          epochs: 'epochs',
          weights: 'weights',
          'image size': 'image_size',
          'target device': 'target_device',
          'dot reference boxes': 'dot_reference_boxes',
          'label fraction (0-1)': 'label_fraction',
          'max labels (0=all)': 'max_labels',
          'max annotations per label (0=all)': 'max_labels',
        };
        if (byExact[parameterName]) {
          return byExact[parameterName];
        }
        // Display names may include ranges/units in parentheses.
        if (parameterName.startsWith('label fraction')) {
          return 'label_fraction';
        }
        if (
          parameterName.startsWith('max labels') ||
          parameterName.startsWith('max annotations per label')
        ) {
          return 'max_labels';
        }
        return null;
      },
      infoIconText() {
          const key = this.infoIconTranslationKey;
          if (!key) {
              return '';
          }
          return this.$t(`models_and_train_configs.${key}`);
      },
      /** Returns options for autocomplete display. Returns objects as-is, converts primitives to strings. */
      str_options() {
          if(!this.options) {
              return this.options;
          }
          // Check if options are objects (not primitives like strings/numbers)
          if (this.options.length > 0 && typeof this.options[0] === 'object' && this.options[0] !== null) {
              // Keep objects as-is for Autocomplete with return-object
              return this.options;
          }
          // Convert primitives to strings
          return this.options.map(option => { return option.toString() });
      },
      yesno () {
        if(!this.options) {
            return false;
        }
        return this.options.length === 2 && this.options[0] === 'Yes' && this.options[1] === 'No';
      },
      selected_option () {
        if(this.value) {
          return this.value;
        }
        return this.default_value
      }
    }
  }
</script>

<style scoped>

</style>
